export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Modificar datos de la certificación"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la certificación"])},
          "cancel_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cancelar"])},
          "save_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Guardar"])}
        }
      }
    }
  })
}